import { Grid } from '@mui/material';
import { FormPart } from '@modules/shared/components/FormPart';
import { getOptions } from '@shared/commonFunctions';
import { CheckboxListField } from '@shared/fields/CheckboxListField';
import { ICustomDocsProps } from '../interface';

export const CustomDocsForm = ({ customDocsList }: ICustomDocsProps) => {
  const list = [
    {
      label: ' ',
      name: 'filterDocumentTypeIds',
      options: getOptions(customDocsList),
      nextLine: true,
      component: CheckboxListField,
    },
  ];
  return (
    <Grid container>
      <FormPart config={list} />
    </Grid>
  );
};
